import React, { useEffect, useRef, useState } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";
import Placeholder from "@tiptap/extension-placeholder";
import * as FeatherIcon from "react-feather";
import "./RichTextEditor.css";

export default function RichTextEditor({ editable = true, onAutoSave, ...rest }) {
  const contentId = rest?.content?.id;
  const [email, setEmail] = useState(rest?.content?.prompt || "");
  const lastSavedContent = useRef(email);
  const skipNextUpdate = useRef(false);
  const debounceTimer = useRef(null); // 🕒 for debouncing

  const editor = useEditor({
    extensions: [
      StarterKit,
      Link.configure({ openOnClick: false }),
      Image,
      Placeholder.configure({ placeholder: "Write your email content here..." }),
    ],
    content: email,
    editable,
    onUpdate: ({ editor }) => {
      if (skipNextUpdate.current) return (skipNextUpdate.current = false);
      const html = editor.getHTML();
      setEmail(html);
      lastSavedContent.current = html;
    },
  });

  // ✅ Debounced Autosave
  useEffect(() => {
    if (!onAutoSave || !email) return;

    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      onAutoSave(contentId, email);
    }, 500); // 500ms delay

    return () => clearTimeout(debounceTimer.current);
  }, [email]);


  useEffect(() => {
    
  
    return () => {
      editor.destroy()
    }
  }, [editor])
  

  useEffect(() => {
    if (!editor) return;
    const latest = rest?.content?.prompt || "";
    if (latest !== lastSavedContent.current) {
      skipNextUpdate.current = true;
      editor.commands.setContent(latest, false);
      lastSavedContent.current = latest;
    }
  }, [rest?.content?.prompt]);

  return (
    <div className={`rte-container ${editable ? "" : "rte-readonly"}`}>
      {editable && (
        <div className="rte-toolbar">
          <button onClick={() => editor.chain().focus().toggleBold().run()}>B</button>
          <button onClick={() => editor.chain().focus().toggleItalic().run()}>I</button>
          <button onClick={() => editor.chain().focus().toggleBulletList().run()}>•</button>
          <button onClick={() => editor.chain().focus().toggleOrderedList().run()}>1.</button>
          <button
            onClick={() => {
              const url = window.prompt("Enter link URL");
              if (url) editor.chain().focus().setLink({ href: url }).run();
            }}
          >
            <FeatherIcon.Link size={14} />
          </button>
        </div>
      )}
      <div className="rte-editor-scroll">
        <EditorContent editor={editor} />
      </div>
    </div>
  );
}
